import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Guest orders are looked up by their order_token (see get_order_by_token
// RPC) — the same token that's in the confirmation page URL right after
// checkout. There's no order-confirmation email yet to re-send that link
// from, so for now this just accepts a pasted token/URL. Worth revisiting
// once transactional email exists for this store.
export default function OrderLookupPage() {
  const [value, setValue] = useState('');
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    const match = trimmed.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
    if (match) navigate(`/order/${match[0]}`);
  };

  return (
    <div className="sv-container sv-page-top sv-page-bottom" style={{ maxWidth: 460 }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: 8 }}>Track your order</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginBottom: 20 }}>
        Paste the order link or token from your confirmation page.
      </p>
      <form onSubmit={submit} style={{ display: 'flex', gap: 8 }}>
        <input
          className="sv-input"
          placeholder="Order link or token"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          required
        />
        <button type="submit" className="sv-btn">Find</button>
      </form>
    </div>
  );
}
